var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrilhaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2076 0.848114C17.8023 0.848114 13.4208 4.26217 13.4208 8.47391C13.4208 11.8789 19.8172 18.0848 22.2677 20.3375C22.7641 20.7938 23.6519 20.7938 24.1474 20.3375C26.598 18.0848 32.9944 11.8789 32.9944 8.47391C32.9944 4.26217 28.6128 0.848114 23.2076 0.848114ZM23.2076 11.0158C21.4056 11.0158 19.9453 9.87802 19.9453 8.47391C19.9453 7.06979 21.4056 5.93197 23.2076 5.93197C25.0096 5.93197 26.4698 7.06979 26.4698 8.47391C26.4698 9.87802 25.0096 11.0158 23.2076 11.0158ZM2.40055 13.9179C1.93931 14.0616 1.54392 14.3097 1.26537 14.6302C0.986814 14.9507 0.837879 15.3289 0.837769 15.716L0.837769 30.8659C0.837769 31.551 1.72557 32.0194 2.54191 31.7653L13.2654 27.962V13.8555C12.5788 12.8884 12.0172 11.9467 11.6149 11.0461L2.40055 13.9179ZM23.2076 22.6161C22.1147 22.6161 21.0809 22.2421 20.3717 21.5897C18.8447 20.1855 17.2205 18.5866 15.751 16.9464V27.9614L30.6642 31.8349V16.947C29.1946 18.5866 27.5712 20.1862 26.0434 21.5903C25.3343 22.2421 24.3004 22.6161 23.2076 22.6161ZM43.8732 10.6019L33.1497 14.4051V31.8355L44.0146 28.4492C44.4759 28.3056 44.8714 28.0575 45.1499 27.7369C45.4285 27.4164 45.5774 27.0382 45.5774 26.6511V11.5012C45.5774 10.8161 44.6896 10.3477 43.8732 10.6019Z",
    fill: "#2299F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrilhaIcon);
export default __webpack_public_path__ + "static/media/trilha_icon.91161625cd35aa758303584c015f538f.svg";
export { ForwardRef as ReactComponent };